import React, { useMemo } from "react";
import { useControl, useControlReducer } from "../../../controlContext";
import { Col, Form, Row } from "react-bootstrap";
import "../../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/address.css"
import { useControlHeaderContext } from "../../../controlWrapperContext";

const schema = [
  { label: 'Address', name: 'streetAddress' },
  { label: 'City/Town', name: 'city' },
  { label: 'State', name: 'state' },
  { label: 'Zip Code', name: 'zipCode' },
]

export function AddressControl({ name, idx }) {
  const { [idx]: block } = useControl()
  const controlReducer = useControlReducer()
  const { settings: { readOnly: allReadOnly, lockMap } } = useControlHeaderContext()
  const readOnly = useMemo(()=>( allReadOnly || ( lockMap && lockMap[block._id] )), [allReadOnly, lockMap, block._id])

  let timeout_id
  function onChange(evt) {
    if (timeout_id) clearTimeout(timeout_id)
    let attr = evt.target.name
    let val = evt.target.value
    console.log('address onChange', attr, val)
    timeout_id = setTimeout(() => controlReducer({ type: 'changed', name, idx, update: {[name]: { ...block.address, [attr]: val }} }), 100)
  }
  return schema.map((itm, i) => (
    <Row key={i} className="full-wide" >
      <Form.Label column sm="3">{itm.label}</Form.Label>
      <Col sm="9">
      {!readOnly? (

        <Form.Control name={itm.name} type="text" onChange={onChange} defaultValue={block.address[itm.name]} />
      ): (
        <div>{block.address[itm.name]}</div>
      )}
      </Col>
    </Row>
  ))
}